/**
 * Fun "Coming Soon" placeholder for portcos that don't have a Shopify store yet.
 */

import { Link, useSearchParams } from "react-router-dom";
import { PortcoSubNav } from "../ui-components/PortcoSubNav";

export function DtcComingSoon() {
  const [params] = useSearchParams();
  const portcoId = params.get("from") || "";
  const portcoName = params.get("name") || "This brand";

  return (
    <div className="w-full max-w-6xl">
      {/* Back link + Sub-nav */}
      {portcoId && (
        <>
          <div className="mb-4">
            <Link
              to={`/portco/${portcoId}`}
              className="text-sm text-gray-400 hover:text-wmp-500 no-underline"
            >
              &larr; Back to {portcoName}
            </Link>
          </div>
          <div className="mb-6">
            <PortcoSubNav portcoId={portcoId} />
          </div>
        </>
      )}

      {/* Coming Soon Card */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="py-20 px-8 text-center">
          {/* Shopping cart icon with sparkles */}
          <div className="relative inline-block mb-6">
            <svg
              className="w-24 h-24 text-gray-200 animate-bounce"
              style={{ animationDuration: "3s" }}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 100 4 2 2 0 000-4z"
              />
            </svg>
            {/* Sparkles */}
            <span
              className="absolute -top-2 -right-2 text-2xl animate-ping"
              style={{ animationDuration: "2s" }}
            >
              *
            </span>
            <span
              className="absolute -bottom-1 -left-3 text-xl animate-ping"
              style={{ animationDuration: "2.5s", animationDelay: "0.5s" }}
            >
              *
            </span>
          </div>

          <h2 className="text-2xl font-bold text-gray-900 mb-3">
            Shopify Store Coming Soon!
          </h2>
          <p className="text-gray-500 text-lg max-w-md mx-auto mb-2">
            {portcoName}'s DTC dashboard is brewing behind the scenes.
          </p>
          <p className="text-gray-400 text-sm max-w-sm mx-auto">
            We're wiring up the Shopify data pipeline. Check back soon for
            revenue trends, top products, cohort analysis, and more.
          </p>

          {/* Fun progress bar */}
          <div className="mt-8 max-w-xs mx-auto">
            <div className="flex justify-between text-xs text-gray-400 mb-1">
              <span>Progress</span>
              <span>Almost there...</span>
            </div>
            <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
              <div
                className="h-full bg-gradient-to-r from-wmp-500 to-wmp-300 rounded-full animate-pulse"
                style={{ width: "42%" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
